<div class="m-3 alert alert-guidance">No {{ label }} have been recorded.</div>
